// extracted by mini-css-extract-plugin
export default {"globalSearch":"globalSearch_globalSearch__NdH6t"};